"use client"

import { useState, useEffect, useRef } from "react"
import "./CareerSelection.css"

const tabs = [
  { key: "step1", title: "SEND YOUR CV", label: "STEP 1" },
  { key: "step2", title: "1ST INTERVIEW", label: "STEP 2" },
  { key: "step3", title: "2ND INTERVIEW", label: "STEP 3" },
  { key: "step4", title: "3RD INTERVIEW", label: "STEP 4" },
  { key: "step5", title: "ASSESS OUR PROPOSAL", label: "STEP 5" },
]

const tabContents = {
  step1: [
    {
      title: "SEND YOUR CV",
      description:
        "Our approach to hiring emphasises a human-centric philosophy that values clear communication and timely feedback. From zero to hired!",
      links: [
        { text: "From zero to hired! Meet our recruitment process",  },
        { text: "Our recruitment process by the eyes of the recruits",  }
      ]
    },
  ],
  step2: [
    {
      title: "1ST INTERVIEW",
      description: "Crush the technical assessment. This is your moment to shine. Our technical assessment is designed to showcase your problem-solving skills, and logical thinking - not to trip you up. It’s short, focused, and directly aligned with the kind of real-world challenges you’ll face on the job.",
      links: []
    }
  ],
  step3: [
    {
      title: "2ND INTERVIEW",
      description: "At Imaginary Cloud, we believe that great teamwork starts with shared values and a strong cultural fit. This stage is all about discovering whether our ways of working, our principles, and our mindset align with yours. It’s a two-way conversation where we get to know you, and you get to understand who we are.",
      links: []
    }
  ],
  step4: [
    {
      title: "3RD INTERVIEW",
      description: "This final stage puts your skills to the test with a practical, real-world problem. It’s your opportunity to demonstrate how you approach complex challenges, apply your expertise, and collaborate effectively under pressure. Show us how you turn problems into solutions.",
      links: []
    }
  ],
  step5: [
    {
      title: "ASSESS OUR PROPOSAL",
      description: "If you get the job (let's hope you do!), take the time to carefully assess how our proposal aligns with your career goals, values, and expectations. We’re here to answer any questions and support you in making the best decision for your future.",
      links: []
    }
  ],
}

const CareerSelection = () => {
  const [activeTab, setActiveTab] = useState("step1")
  const progressBarRef = useRef(null)

  useEffect(() => {
    const index = tabs.findIndex(tab => tab.key === activeTab)
    const progress = ((index + 1) / tabs.length) * 100
    if (progressBarRef.current) {
      progressBarRef.current.style.width = `${progress}%`
    }
  }, [activeTab])

  return (
    <section className="career-selection-section" id="selection">
      <div className="container">
      <div className="career-selection-title">
        <h2>WHAT TO EXPECT FROM OUR <br /><span>SELECTION PROCESS</span></h2>
      </div>

      <div className="career-selection-card">
        {/* Tab Bar */}
        <div className="selection-tab-bar">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`selection-tab-btn ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              <span className="step-label">{tab.label}</span>
              <span className="step-title">{tab.title}</span>
            </button>
          ))}
          <div className="selection-tab-progress">
            <div className="selection-tab-bar-fill" ref={progressBarRef}></div>
          </div>
        </div>

        {/* Content */}
        <div className="selection-tab-content">
          {tabContents[activeTab].map((item, i) => (
            <div key={i} className="selection-content-card">
              <p className="step-label">{tabs.find(t => t.key === activeTab)?.label}</p>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
              {item.links && (
                <ul>
                  {item.links.map((link, i) => (
                    <li key={i}>
                      <a href={link.href} target="_blank" rel="noopener noreferrer">{link.text}</a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
      </div>
    </section>
  )
}

export default CareerSelection
